import { createAction } from "@reduxjs/toolkit";

export const setSponsorError = createAction<string | null>("sponsor/setError");
